export const BASE_PATH = process.env.ASSET_PATH || '';

export const AUTH = '/auth';
export const UPGRADE = '/upgrade';
export const UPGRADE_LEGACY = '/upgrade-legacy';
export const SUCCESS = '/success';
export const FAILED = '/failed';

export const ROUTE_CODES = {
  HOME: '/',

  AUTH,
  LOGIN: `${AUTH}/login`,
  SIGNUP: `${AUTH}/signup`,
  FORGOT_PASSWORD: `${AUTH}/forgotten-password`,
  RESET_PASSWORD: '/reset-password/:token',

  SCRIBE_NEW: '/new-project',
  SCRIBE_DELETE: '/delete/:scribeId',
  TEMPLATE_PREVIEW: '/template-preview/:templateId',
  MY_SCRIBES: '/my-projects',

  RENDER: '/render/:scribeId/:startTime?/:duration?',

  EDITOR: '/editor/:scribeId',
  SHARE: '/share',
  UPGRADE,
  UPGRADE_LEGACY,
  SUCCESS: `${SUCCESS}/:refId?`,
  FAILED,
  ELEM_ADD: '/add/:elementType',
  HANDS: '/hands',
  OPTIONS: '/options',

  ZUORA_CALLBACK: '/zuora-callback',
  CONTENTFUL_CALLBACK: '/contentful-callback'
};
